// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1HK-f","fileBtn":"File_fileBtn__3i9YI","closeBtn":"File_closeBtn__2JL7s","fileSelected":"File_fileSelected__1wRJv","disabled":"File_disabled__27wLk"};